import { getMenuList as fetchMenuList } from '@/api/auth'

// 异步路由（从路由配置中筛选需要权限的路由）
const asyncRoutes = []

/**
 * 使用meta.role确定当前用户是否具有权限
 * @param roles 用户角色
 * @param route 路由
 */
function hasPermission(roles, route) {
  if (route.meta && route.meta.roles) {
    return roles.some(role => route.meta.roles.includes(role))
  } else {
    return true
  }
}

/**
 * 递归过滤异步路由表，返回符合用户角色权限的路由表
 * @param routes asyncRoutes 异步路由表
 * @param roles 用户角色
 */
export function filterAsyncRoutes(routes, roles) {
  const res = []
  
  routes.forEach(route => {
    const tmp = { ...route }
    if (hasPermission(roles, tmp)) {
      if (tmp.children) {
        tmp.children = filterAsyncRoutes(tmp.children, roles)
      }
      res.push(tmp)
    }
  })
  
  return res
}

const state = {
  routes: [],
  addRoutes: [],
  menuList: []
}

const mutations = {
  SET_ROUTES: (state, routes) => {
    state.addRoutes = routes
    state.routes = routes
  },
  SET_MENU_LIST: (state, menuList) => {
    state.menuList = menuList
  }
}

const actions = {
  generateRoutes({ commit }, roles) {
    return new Promise(resolve => {
      let accessedRoutes
      if (roles.includes('admin') || roles.includes('superadmin')) {
        accessedRoutes = asyncRoutes || []
      } else {
        accessedRoutes = filterAsyncRoutes(asyncRoutes, roles)
      }
      commit('SET_ROUTES', accessedRoutes)
      resolve(accessedRoutes)
    })
  },
  
  getMenuList({ commit }) {
    return new Promise((resolve, reject) => {
      // 调用后端接口获取菜单列表
      fetchMenuList().then(menuList => {
        commit('SET_MENU_LIST', menuList || [])
        resolve(menuList || [])
      }).catch(err => {
        // 后端不可用时回退到静态菜单
        const menuList = [
          {
            id: 1,
            name: 'dashboard',
            title: '仪表盘',
            icon: 'dashboard',
            path: '/dashboard',
            sort: 1,
            children: []
          },
          {
            id: 2,
            name: 'organization',
            title: '组织架构',
            icon: 'office-building',
            path: '/organization',
            sort: 2,
            children: []
          },
          {
            id: 3,
            name: 'resident',
            title: '居民管理',
            icon: 'user',
            path: '/resident',
            sort: 3,
            children: []
          },
          {
            id: 4,
            name: 'payment',
            title: '缴纳管理',
            icon: 'document',
            path: '/payment',
            sort: 4,
            children: [
              {
                id: 41,
                name: 'payment-list',
                title: '缴纳清单',
                icon: 'list',
                path: '/payment/list',
                sort: 1
              },
              {
                id: 42,
                name: 'payment-task',
                title: '待缴任务',
                icon: 'task',
                path: '/payment/task',
                sort: 2
              }
            ]
          },
          {
            id: 5,
            name: 'statistics',
            title: '统计分析',
            icon: 'trend-charts',
            path: '/statistics',
            sort: 5,
            children: []
          },
          {
            id: 6,
            name: 'user',
            title: '个人中心',
            icon: 'setting',
            path: '/user',
            sort: 6,
            children: []
          }
        ]
        commit('SET_MENU_LIST', menuList)
        reject(err)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}